<template>
  <div class="container">
    <titular />
    <ul class="list-group list-group-flush col-12 col-md-6 mx-auto">
      <li v-for="(dia, index) in ordenados" :key="index" class="list-group-item d-flex justify-content-between align-items-center">
        {{ dia.formateado }}
        <modal :ref="`modalEliminacion${dia.id}`" titulo="Eliminar festiu" icono="fa-solid fa-trash-can" btnClass="btn-secondary" :hayLanzador="false" :modalId="`eliminar-${dia.id}`" :loading="loading.eliminacion" @abrir="abrirModal(`autofocusEliminacion${dia.id}`)" @cerrar="cerrarEliminacion">
          <template v-slot:body>
            <div class="alert alert-warning" role="alert"><i class="fa-solid fa-triangle-exclamation mr-1"></i>Aquesta acció no es pot desfer.</div>
            Vols eliminar el festiu <b>{{ dia.formateado }}</b
            >?
          </template>
          <template v-slot:footer>
            <button :ref="`autofocusEliminacion${dia.id}`" type="submit" class="btn btn-danger" :disabled="loading.eliminacion" @click="eliminar(dia.id)"><i-submit icono="fa-trash-can" :loading="loading.eliminacion" />Confirmar</button>
          </template>
        </modal>
        <button class="btn btn-secondary btn-sm" data-toggle="modal" :data-target="`#modal-eliminar-${dia.id}`" title="Eliminar festiu" v-tooltip><i class="fa-solid fa-trash-can"></i></button>
      </li>
      <li class="list-group-item">
        <form @submit.prevent="crearFestivo">
          <fieldset :disabled="loading.creacionFestivo">
            <div class="input-group w-50">
              <input type="date" class="form-control" :min="minFecha" v-model="nuevos.festivo_empresa.festiu_empresa" required />
              <div class="input-group-append">
                <button class="btn btn-secondary" title="Afegir festiu" v-tooltip><i class="fa-solid fa-plus"></i></button>
              </div>
            </div>
          </fieldset>
        </form>
      </li>
    </ul>
  </div>
</template>
        
  <script>
export default {
  name: "",
  data() {
    return {
      loading: {
        creacionFestivo: false,
        eliminacion: false,
      },
      festivos_empresa: [],
      nuevos: {
        festivo_empresa: {
          festiu_empresa: "",
        },
      },
    };
  },
  computed: {
    minFecha: function () {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      return tomorrow.toISOString().split("T")[0];
    },
    ordenados() {
      if (!this.festivos_empresa) return [];

      return this.festivos_empresa.sort(function (a, b) {
        return new Date(a.festiu_empresa) - new Date(b.festiu_empresa);
      });
    },
  },
  methods: {
    getData() {
      this.$http.get("api/festius_empresa").then((response) => (this.festivos_empresa = response.data));
    },
    crearFestivo: function () {
      this.loading.creacionFestivo = true;

      this.$http
        .post("api/festius_empresa", this.nuevos.festivo_empresa)
        .then((response) => {
          if (response.status == 201) {
            if (!this.festivos_empresa) {
              this.festivos_empresa = [];
            }

            this.festivos_empresa.push(response.data);

            this.$toast.clear();
            this.$toast.open({ position: "top", message: `Festiu empresa afegit correctament.` });
          }
        })
        .finally(() => (this.loading.creacionFestivo = false));
    },
    eliminar: function (id) {
      this.loading.eliminacion = true;

      this.$http
        .delete(`api/festius_empresa/${id}`)
        .then((response) => {
          this.loading.eliminacion = false;

          this.$nextTick(function () {
            this.$refs[`modalEliminacion${id}`][0].cerrar();

            if (response.status == 200) {
              const found = this.festivos_empresa.find((element) => element.id == id);
              found.eliminado = true;

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Festiu eliminat correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.eliminacion = false;
        });
    },
    cerrarEliminacion: function () {
      if (!this.festivos_empresa) return;

      this.festivos_empresa = this.festivos_empresa.filter(function (item) {
        return item.eliminado != true;
      });
    },
    abrirModal: function (autofocus) {
      $(this.$refs[autofocus]).trigger("focus");
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    festivos_empresa() {
      if (!this.festivos_empresa) return;

      this.festivos_empresa.map((a) => {
        a.formateado = new Date(a.festiu_empresa).toLocaleString(this.locale, { day: "numeric", month: "long", year: "numeric" });

        return a;
      });
    },
  },
};
</script>
    
  <style lang="scss" scoped>
</style>